export default "__VITE_ASSET__d680746e__"